import theme from 'config/theme';
import { URLS } from 'layouts/DrawerLayout/constants';

export const TICKETS_TYPES = {
  GENERIC_REQUEST: 'generic_request',
  ARNM_MAINTENANCE: 'arnm_maintenance',
};

export const TICKETS_TYPES_OPTIONS = [
  {
    value: TICKETS_TYPES.GENERIC_REQUEST,
    text: 'Generic Ticket',
    url: URLS.genericTickets,
  },
  {
    value: TICKETS_TYPES.ARNM_MAINTENANCE,
    text: 'ARNM Maintenance',
    url: URLS.arnmMaintenance,
  },
];

export const HIGHLIGHT_STYLE = {
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  fontWeight: 600,
};

export const ARNM_MAINTENANCE_DEFAULT_VALUES = {
  status: 0,
  assignee: null,
  ticketType: null,
  customFields: {
    userEmail: '',
    subscriptionId: '',
    carId: '',
    pipedriveId: '',
    reason: '',
    doWeNeedATempCar: false,
    temporaryCarId: '',
    kilometers: '',
    dateToServicePoint: '',
    servicePoint: null,
    expectedOutFromServicePoint: '',
  },
};

export const CONNECT_TICKET_TO_TYPES = {
  bookings: { text: 'Bookings', value: 'bookings' },
  subscriptions: { text: 'Subscriptions', value: 'subscriptions' },
};

export const CONNECT_TICKET_TO_OPTIONS = Object.values(CONNECT_TICKET_TO_TYPES);

export const VALID_CONNECT_TICKET_TO_VALUES = Object.values(
  CONNECT_TICKET_TO_TYPES
).map((type) => type.value);
